import {useCallback, useMemo} from 'react';

import {useCustomers} from '../../customers/hooks/useCustomers.ts';
import {Customer} from '../../customers/types.ts';
import {customerLabelById} from '../../customers/utils/customerLabel.ts';

// FNP-773: resolve customerId → a human label instead of printing the raw UUID. Build a
// lookup from the loaded customers; unresolved ids fall back to a shortened id inside
// customerLabelById. Only the customers useCustomers has loaded resolve; the rest show
// the shortened id.
export const useCustomerLabels = () => {
    const {items: customers} = useCustomers();
    const customersById = useMemo(
        () => new Map<string, Customer>((customers || []).map((c: Customer) => [c.id, c])),
        [customers],
    );

    return useCallback(
        (customerId: string) => customerLabelById(customerId, customersById),
        [customersById],
    );
};
